import React from 'react';

const Container = (props) => {
  return <div className=" p-24px pt-0px pr-32px">{props.children}</div>;
};

export default Container;
